"use client";

import React from "react";
import styles from "./typography.module.css";

export type DescriptionSize = "small" | "medium" | "large";

export interface DescriptionProps extends React.HTMLAttributes<HTMLParagraphElement> {
  children?: React.ReactNode;
  size?: DescriptionSize;
  color?: string;
  align?: "center" | "left" | "right" | "justify";
  as?: "p" | "span" | "div";
  className?: string;
  style?: React.CSSProperties;
}

export const AppDescription: React.FC<DescriptionProps> = ({
  children,
  size = "medium",
  color,
  align = "left",
  as: Component = "p",
  className = "",
  style,
  ...rest
}) => {
  const sizeClass =
    size === "large"
      ? styles.descSizeLarge
      : size === "small"
        ? styles.descSizeSmall
        : styles.descSizeMedium;

  return (
    <Component
      className={`${styles.description} ${sizeClass} ${className}`.trim()}
      style={{
        color: color || undefined,
        textAlign: align,
        ...style,
      }}
      {...rest}
    >
      {children}
    </Component>
  );
};

export const Description = AppDescription;
export default AppDescription;
